type HighlightedTextProps = {
  text: string;
  term?: string | null;
};

// Escapes special characters in a string to safely use in RegExp
const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const HighlightedText = ({ text, term }: HighlightedTextProps) => {
  if (!term?.trim()) return text;

  const cleanTerm = term.replace(/"/g, '').trim();
  const regex = new RegExp(`\\b(${escapeRegExp(cleanTerm)})\\b`, 'gi');
  const parts = text.replace(/\r?\n|\r/g, ' ').split(regex);

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = part.toLowerCase() === cleanTerm.toLowerCase();
        const key = `${part}-${i}`;
        return isMatch ? <em key={key}>{part}</em> : <span key={key}>{part}</span>;
      })}
    </>
  );
};

export default HighlightedText;
